<template>
<div class="chapter">
<div class="inner_page">
<p class="SP"> </p>
<p class="BM-Head-bmh"><span href="#/xhtml/contents#ack" title="Link target outside of Sample"><span class="ePub-B">ACKNOWLEDGMENTS</span></span></p>
<p class="BM-Text-No-Indent-Space-After-bmtx1-">Thank you to:</p>
<p class="BM-Text-Space-After-bmtx-">Sarah Bowlin, my talented and generous editor, who made this book so much better.</p>
<p class="BM-Text-Space-After-bmtx-">Elisabeth Weed, my agent, friend, and advocate from the beginning.</p>
<p class="BM-Text-Space-After-bmtx-">All the folks at Henry Holt. Every writer should have a team this good.</p>
<p class="BM-Text-Space-After-bmtx-">My first readers: Alex Darrow, Susannah Meadows, Jessica Darrow, and Michelle Wildgen, whose kindness and guidance nudged me forward from a first draft.</p>
<p class="BM-Text-Space-After-bmtx-">Christina Paige. Boise City, baby!</p>
<p class="BM-Text-Space-After-bmtx-">Jennifer Sey, Mark Sundeen, April Saks, Carolyn Frazier, Andrew Wilcox, Lance McDaniel, Amy Sweigert, Carol Lawson, Lynn Kilpatrick, Darin Strauss, Lewis Buzbee, Sabine Laerum, Emma Fusco-Straub, Curtis Sittenfeld, Emily Bell, Michael Donohue, Dune Lawrence, David Khoury, Maartje Oldenburg, Melissa Kantor, Ben Gantcher, Rebekah Coleman, Meredith and Jennifer Bell, Aaron Sanders, and Denise Wood Hahn.</p>
<p class="BM-Text-Space-After-bmtx-">The Twin Cities contingent: Pamela Klinger-Horn, Beth Slater Winnick, Nina Roberson, Frank Bures, Bridgit Jordan, Jeff Chen, and Karen Ho.</p>
<p class="BM-Text-Space-After-bmtx-">My friends from the University of Utah Creative Writing Program.</p>
<p class="BM-Text-Space-After-bmtx-">Bob Barry and the Wednesday crew at the LIU pottery studio.</p>
<p class="BM-Text-Space-After-bmtx-">The Meadows and Darrow families, always.</p>
<p class="BM-Text-Space-After-bmtx-">Alex, Indigo, and Olive. You are the best.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?f027801c